import React from 'react';

const base =
  'inline-flex items-center justify-center gap-2 font-body font-medium rounded-button transition-all duration-150 ' +
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 ' +
  'disabled:opacity-50 disabled:pointer-events-none select-none';

const variants = {
  primary: 'bg-primary text-white hover:opacity-90 active:scale-[0.98] shadow-sm',
  secondary: 'border border-primary text-primary bg-white hover:bg-background active:scale-[0.98]',
  tertiary: 'text-secondary hover:text-primary hover:bg-background/80',
  danger: 'bg-danger text-white hover:opacity-90 active:scale-[0.98]',
  success: 'bg-success text-white hover:opacity-90 active:scale-[0.98]',
};

const sizes = {
  sm: 'h-9 px-3.5 text-small gap-1.5',
  md: 'h-11 px-5 text-body gap-2',
  lg: 'h-12 px-6 text-body font-semibold gap-2.5',
};

export function Button({
  variant = 'primary',
  size = 'md',
  loading = false,
  disabled = false,
  className = '',
  children,
  ...props
}) {
  return (
    <button
      disabled={disabled || loading}
      className={`${base} ${variants[variant]} ${sizes[size]} ${className}`}
      {...props}
    >
      {loading && (
        <svg className="animate-spin -ml-1 mr-1 h-4 w-4 text-current" fill="none" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
        </svg>
      )}
      {children}
    </button>
  );
}

export default Button;